import styled from "@emotion/styled";
import { StarIcon } from "src/assets/icons";

export const BadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 251, 235, 1);
  border: 1px solid rgba(232, 223, 188, 1);
  border-radius: 8px;
  color: rgba(141, 112, 0, 1);
  margin: 0 0.3em;
  padding: 0px 6px 2px 8px;
`;

export default () => {
  return (
    <BadgeWrapper>
      primary <StarIcon />
    </BadgeWrapper>
  );
};
